import { useQuery } from '@tanstack/react-query'
import { getRedisBalances, getAccountDailyConsumables, getLiveCampaignEventCounts } from '../api/balanceInspector'

export function useRedisBalances(accountId: string | null) {
  return useQuery({
    queryKey: ['redis-balances', accountId],
    queryFn: () => getRedisBalances(accountId!),
    enabled: !!accountId,
  })
}

export function useAccountDailyConsumables(accountId: string | null, date: string) {
  return useQuery({
    queryKey: ['account-daily-consumables', accountId, date],
    queryFn: () => getAccountDailyConsumables(accountId!, date),
    enabled: !!accountId,
  })
}

export function useLiveCampaignEventCounts(accountId: string | null, date: string) {
  return useQuery({
    queryKey: ['live-campaign-event-counts', accountId, date],
    queryFn: () => getLiveCampaignEventCounts(accountId!, date, date),
    enabled: !!accountId,
  })
}
